// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "-" + {"34":"1dbd1ffce730cb4c338d","37":"f02ee1a06a9188d27c59","100":"170be9f6403a22cef635","796":"95723442861a6f027556"}[chunkId] + ".css";
};